import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=416e5cca&scoped=true"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"
import style0 from "./register-form.vue?vue&type=style&index=0&id=416e5cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e5cca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VInput: require('/var/www/tubber-new/components/global/v/input.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
